"use client";

import React from "react";
import { motion } from "framer-motion";
import { MapPin, Shield, UserCheck } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
interface BenefitItem {
  id: string;
  title: string;
  description: string;
  icon: React.ComponentType<{
    className?: string;
  }>;
}
const benefits: BenefitItem[] = [{
  id: "route-flexibility",
  title: "Sie bestimmen die Route",
  description: "Teilen Sie uns Ihre bevorzugte Route und Zwischenstopps mit. Wir bestätigen Reiseroute, Dauer und Preis, bevor Ihre Buchung abgeschlossen wird.",
  icon: MapPin
}, {
  id: "chauffeur-standby",
  title: "Persönlicher Chauffeur auf Abruf",
  description: "Ihr lizenzierter Fahrer bleibt während des gesamten Reservierungszeitraums vor Ort bereit, um sofort abzufahren, sobald Sie eintreffen.",
  icon: UserCheck
}, {
  id: "fleet-comfort",
  title: "Komfort mit privatem Fahrzeug & Fahrer",
  description: "Ein modernes, klimatisiertes und desinfiziertes Fahrzeug exklusiv für Ihre Reisegruppe – inklusive Kraftstoff und aller Autobahngebühren.",
  icon: Shield
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.06
    }
  }
};
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 16
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.21, 0.47, 0.32, 0.98]
    }
  }
};
export default function WhatsIncluded() {
  return <section id="whatsincluded" data-nav="light" className="relative bg-background text-foreground py-20 md:py-28 overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="text-center max-w-2xl mx-auto mb-14 md:mb-18">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-foreground font-default">
            Was enthalten ist
          </h2>
          <p className="mt-4 text-base sm:text-lg text-muted-foreground leading-relaxed">
            Wir bestätigen vor der Buchung, welche Leistungen im vereinbarten Preis enthalten sind.
          </p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: "-50px"
      }} className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 items-stretch">
          {benefits.map((item, index) => {
          const Icon = item.icon;
          return <motion.div key={item.id} data-index={index} variants={cardVariants} className="h-full">
                <Card className="h-full bg-card border border-border rounded-3xl shadow-sm hover:shadow-md transition-shadow duration-300 p-8 flex flex-col justify-between">
                  <div>
                    <CardHeader className="p-0 mb-6">
                      <div className="size-14 rounded-2xl bg-primary/20 flex items-center justify-center text-accent-foreground mb-6">
                        <Icon className="size-7" />
                      </div>
                      <CardTitle className="text-xl sm:text-2xl font-bold text-accent-foreground tracking-tight">
                        {item.title}
                      </CardTitle>
                    </CardHeader>
                    <CardContent className="p-0">
                      <p className="text-muted-foreground text-base leading-relaxed">
                        {item.description}
                      </p>
                    </CardContent>
                  </div>
                </Card>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}